module.exports = __webpack_public_path__ + "img/ClickCard.1c093942.png";